import customerReviewsUrl from './customerReviewsComponent.html';

class CustomerReviewsController {
  $onInit() {
    this.reviews = [
      {
        author: 'Andrew Luna, PAZ Veterinary',
        content:
          '"We are more efficient in scheduling and in running payroll with Sling. Geofencing for the time clock is a great feature and has helped us to avoid employee padding hours."',
      },
      {
        author: 'Eddie Dyer, Vessel Nola',
        content:
          '"Sling has helped to cut down on labor costs by making managers accountable for forecasting labor and then tracking against it. It has also prevented possible overtime issues while making scheduling more efficient in general."',
      },
    ];

    this.setReview();
  }

  setReview() {
    const idx = Math.floor(Math.random() * this.reviews.length);
    this.review = this.reviews[idx];
  }

  onBuyHandler() {
    this.buyCallback?.();
  }
}

export default {
  controller: CustomerReviewsController,
  controllerAs: 'ctrl',
  templateUrl: customerReviewsUrl,
  bindings: {
    feature: '@',
    buyCallback: '&?',
  },
};
